import React from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import useSessionDebugInfo from '../hooks/useSessionDebugInfo';
import css from './SessionDebugPanel.css';

const SessionDebugPanel = ({ sessionId, refreshKey = 0, onClose }) => {
    const { data, error } = useSessionDebugInfo(sessionId, refreshKey);

    const renderCloseButton = () => onClose && (
        <Icon
            name="x"
            size={IconSizes.SMALL}
            className={css.closeButton}
            onClick={onClose}
            aria-label="Close session debug"
        />
    );

    if (!sessionId) return null;

    if (error) {
        return (
            <section aria-label="Session debug" className={css.panel}>
                <div className={css.header}>
                    <span>Session debug</span>
                    {renderCloseButton()}
                </div>
                <span className={css.error}>{error}</span>
            </section>
        );
    }

    if (!data) return null;

    const {
        impersonated_user_email: impersonatedUserEmail,
        langfuse_session_url: langfuseSessionUrl,
        langfuse_traces_url: langfuseTracesUrl,
        s3_artifact_prefix: s3ArtifactPrefix,
    } = data;

    return (
        <section aria-label="Session debug" className={css.panel}>
            <div className={css.header}>
                <span>Session debug</span>
                {renderCloseButton()}
            </div>
            <div className={css.body}>
                <div className={css.row}>
                    <span className={css.label}>User</span>
                    <code className={css.code}>{data.user_email}</code>
                </div>
                {impersonatedUserEmail && (
                    <div className={css.row}>
                        <span className={css.label}>Impersonated as</span>
                        <code className={css.code}>{impersonatedUserEmail}</code>
                    </div>
                )}
                <div className={css.row}>
                    <span className={css.label}>Langfuse session</span>
                    {langfuseSessionUrl ? (
                        <a className={css.link} href={langfuseSessionUrl} target="_blank" rel="noopener noreferrer">
                            View session →
                        </a>
                    ) : (
                        <span className={css.muted}>not available</span>
                    )}
                </div>
                <div className={css.row}>
                    <span className={css.label}>Langfuse traces</span>
                    {langfuseTracesUrl ? (
                        <a className={css.link} href={langfuseTracesUrl} target="_blank" rel="noopener noreferrer">
                            View agent traces →
                        </a>
                    ) : (
                        <span className={css.muted}>not available</span>
                    )}
                </div>
                <div className={css.row}>
                    <span className={css.label}>S3 artifact store</span>
                    {s3ArtifactPrefix
                        ? <code className={css.code}>{s3ArtifactPrefix}</code>
                        : <span className={css.muted}>not available</span>}
                </div>
            </div>
        </section>
    );
};

SessionDebugPanel.propTypes = {
    sessionId: PropTypes.string,
    refreshKey: PropTypes.number,
    onClose: PropTypes.func,
};

export default SessionDebugPanel;
